import React, { Component } from "react";
import Modal from "@material-ui/core/Modal";

class DraggableModal extends Component {
  dragElement = elmnt => {
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;

    elmnt.getElementsByClassName("modalHeader")[0].onmousedown = dragMouseDown;

    function dragMouseDown(e) {
      if (
        !e.target.parentElement.parentElement.classList.contains(
          "modal-minimizado"
        )
      ) {
        e = e || window.event;
        e.preventDefault();
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        document.onmousemove = elementDrag;
      }
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      elmnt.style.top = elmnt.offsetTop - pos2 + "px";
      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }

    function closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    }
  };

  handleDraggable = () => {
    let self = this;
    let list = document.getElementsByClassName("modal");
    for (var i = 0; i < list.length; i++) {
      self.dragElement(list[i].lastChild);
    }
  };
  render() {
    return <Modal {...this.props} onRendered={() => this.handleDraggable()} />;
  }
}

export default DraggableModal;



// WEBPACK FOOTER //
// ./src/components/DraggableModal/index.js